import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { ContentContainer } from "./HXMobilePage.styles";
import { DividerLine } from "./PatientConsentLoginView.styles";
import { CheckCircleIcon, ConfirmButton, DescriptionIcon, FooterPlaceholderButton, PageWithFixedHeaderAndFooterContent, PatientConsentParent, SecurityIcon, } from "./PatientConsentManagerShared.styles";
import { ScreenshotReadinessDetector } from "./ScreenshotReadinessDetector";
import React from "react";
import { DividerContainer, DividerLineWrapper, StepIconContainer, StepRow, StepsContainer, StepText, StepTextContainer, } from "./DocumentRetrievalRecordsShared.styles";
import { PatientConsentHowItWorksViewModel } from "./PatientConsentHowItWorksViewModel";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { useViewModel } from "./useViewModel";
export const PatientConsentHowItWorksView = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(PatientConsentHowItWorksViewModel, props.container);
    const steps = [
        {
            id: "identity-verified",
            text: t("Verify your identity"),
            icon: _jsx(SecurityIcon, {}),
        },
        {
            id: "access-confirmed",
            text: model.howItWorksFindRecordsText,
            icon: _jsx(DescriptionIcon, {}),
        },
        {
            id: "sharing-records",
            text: model.howItWorksReviewRecordsText,
            icon: _jsx(CheckCircleIcon, {}),
        },
    ];
    const animate = false;
    return (_jsx(ScreenshotReadinessDetector, { isScreenshotMode: model.isScreenshotMode, children: _jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: model.isHeaderAndFooterFixed, children: _jsx(PatientConsentParent, { children: _jsx(ContentContainer, { children: _jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: model.howItWorksTitle, supportingText: model.howItWorksSupportingText, buttons: _jsxs(_Fragment, { children: [_jsx(ConfirmButton, { onClick: () => model.continue(), children: t("Continue") }), _jsx(FooterPlaceholderButton, {})] }), animate: animate, children: (isAnimating) => (_jsx(StepsContainer, { isAnimating: isAnimating, animate: animate, children: steps.map((step, index) => (_jsxs(React.Fragment, { children: [_jsxs(StepRow, { children: [_jsx(StepIconContainer, { children: step.icon }), _jsx(StepTextContainer, { children: _jsx(StepText, { children: step.text }) })] }), index < steps.length - 1 && (_jsxs(DividerContainer, { children: [_jsx(DividerLineWrapper, {}), _jsx(DividerLine, {})] }))] }, step.id))) })) }) }) }) }) }));
});
addDisplayName(PatientConsentHowItWorksView, "PatientConsentHowItWorksView");
